<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                equipmentItemForm: () => import('../forms/EquipmentItemForm'),
                fileForm: () => import('../forms/FileForm'),
                fields: [
                    { type: 'autocomplete', text: 'Equipment Item', value: 'equipmentItemId', rules: [v => !!v || 'Equipment Item is required'], isRequired: true, form: () => import('./EquipmentItemForm'), apiMethod: 'EquipmentItems', claim: 'EquipmentItems' },
                    { type: 'datetime', text: 'On', value: 'on', rules: [v => !!v || 'On is required'], isRequired: true },
                    { type: 'checkbox', text: 'Has Passed', value: 'hasPassed', rules: [v => (v !== null && v !== '') || 'Has Passed is required'], isRequired: true },
                    { type: 'file', text: 'Invoice File', value: 'invoiceFileId', rules: [], form: () => import('./FileForm'), apiMethod: 'Files' },
                    { type: 'file', text: 'Record File', value: 'recordFileId', rules: [], form: () => import('./FileForm'), apiMethod: 'Files' },
                    { type: 'number', text: 'Weight Calibrated', value: 'weightCalibrated', rules: [] },
                    { type: 'text', text: 'Calibrated By Company', value: 'calibratedByCompany', rules: [v => !(v && v.length > 100) || 'Calibrated By Company must be less than 100 characters'], maxLength: 100 },
                ],
                apiMethod: 'Calibrations',
                formTitle: 'Calibration',
            }
        },
    };
</script>
